export const EXCLUSTION_TYPE = {
  URL: 'urls',
  Rule: 'urlContains',
  Label: 'customLabels',
};

export const URL_LENGTH_LIMIT = 2048;
